import React, { useState } from "react"

import { styled } from "@mui/material/styles"

import { Link } from "@cirrus/ui-kit-ts"

import { CommentForm } from "./CommentForm"
import { MessageItem } from "./MessageItem"
import { IComment } from "../types/IComment"
import { IPostComment } from "../types/IPostComment"

interface IProps<T extends IComment<T, TMention, TRole>, TMention, TRole> extends IComment<T, TMention, TRole> {
  toggleLike: (id: string) => void,
  onDelete: (id: string) => void,
  onSend: (comment: IPostComment) => void
  getCommentRole?: (comment: T) => string
}

export const Message = <T extends IComment<T, TMention, TRole>, TMention, TRole>({
                                                                                   toggleLike,
                                                                                   onDelete,
                                                                                   onSend,
                                                                                   getCommentRole,
                                                                                   ...item
                                                                                 }: IProps<T, TMention, TRole>) => {

  const [showReplies, setShowReplies] = useState(false)
  const [reply, setReply] = useState<boolean>(false)

  const toggleReply = () => setReply(!reply)

  const toggleShowReplies = () => {
    if (showReplies || reply) {
      setReply(false)
      setShowReplies(false)
      return
    }

    setShowReplies(true)
  }

  const onReply = (comment: IPostComment) => {
    onSend({ ...comment, parentId: item.id })
    setReply(false)
  }

  return <div>
    <MessageItem
      toggleLike={toggleLike}
      onDelete={onDelete}
      onEdit={onSend}
      toggleReply={toggleReply}
      getCommentRole={getCommentRole}
      {...item} />
    {
      (item.replies || []).length > 0
      &&
      <Link size={"medium"}
            sx={{ marginLeft: "3.4rem" }}
            onClick={toggleShowReplies}>
        {
          (showReplies || reply)
            ? "Hide replies"
            : `${(item.replies || []).length} replies`
        }
      </Link>
    }

    {
      (showReplies || reply)
      &&
      <MessagesWrapper
        style={{
          marginTop: (item.replies || []).length > 0
            ? 0
            : "2rem"
        }}>
        {(item.replies || [])
          .map((item) =>
            <MessageItem
              key={item.id}
              toggleLike={toggleLike}
              onDelete={onDelete}
              onEdit={onSend}
              toggleReply={toggleReply}
              getCommentRole={getCommentRole}
              {...item}
              isReply />
          )}
        {
          reply
          && <ReplyWrapper>
            <CommentForm onSend={onReply}
                         placeholder="Reply" />
          </ReplyWrapper>
        }
      </MessagesWrapper>
    }

  </div>
}

const ReplyWrapper = styled("div")({
  marginLeft: "2.8rem"
})

const MessagesWrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "2rem"
})
